/*
  DISTANT TRAVELER
  Precision cassette wheel controller

  IMPORTANT:
  Uses the SAME shared audio object as distant-player.js

  DO NOT:
  - create another Audio()
  - change cassette geometry
  - change wheel positions
  - change transform-origin
*/

(() => {
  const VERSION = "precision-spin-v2";

  let rafId = null;


  /* =========================================================
     GET EXISTING SHARED AUDIO
  ========================================================= */

  function getAudio() {
    return (
      window.DistantTravelerPlayer?.audio ||
      null
    );
  }


  /* =========================================================
     GET CASSETTE ELEMENTS
  ========================================================= */

  function getCassetteParts() {
    const cassette =
      document.querySelector(
        ".dt-cassette"
      );


    if (!cassette) {
      return null;
    }


    const leftWheel =
      cassette.querySelector(
        ".dt-cassette__wheel--left"
      );


    const rightWheel =
      cassette.querySelector(
        ".dt-cassette__wheel--right"
      );


    if (
      !leftWheel ||
      !rightWheel
    ) {
      return null;
    }


    return {
      cassette,
      leftWheel,
      rightWheel
    };
  }


  /* =========================================================
     RENDER FROM REAL SONG TIME
  ========================================================= */

  function render() {
    const audio =
      getAudio();


    const parts =
      getCassetteParts();


    if (
      !audio ||
      !parts
    ) {
      rafId = null;
      return;
    }


    /*
      EXACT APPROVED ROTATION

      LEFT:
      -(audio.currentTime × 126deg)

      RIGHT:
      +(audio.currentTime × 126deg)
    */

    const angle =
      (
        audio.currentTime *
        126
      ) %
      360;


    parts.leftWheel.style.transform =
      `rotate(${-angle}deg)`;


    parts.rightWheel.style.transform =
      `rotate(${angle}deg)`;


    /*
      Keep rendering only while playing.
    */

    if (
      !audio.paused &&
      !audio.ended
    ) {
      rafId =
        window.requestAnimationFrame(
          render
        );

    } else {
      rafId = null;
    }
  }


  /* =========================================================
     START
  ========================================================= */

  function startRendering() {
    if (rafId !== null) {
      return;
    }


    rafId =
      window.requestAnimationFrame(
        render
      );
  }


  /* =========================================================
     CONNECT TO EXISTING PLAYER
  ========================================================= */

  function bindAudio() {
    const audio =
      getAudio();


    const parts =
      getCassetteParts();


    if (
      !audio ||
      !parts
    ) {
      return false;
    }


    /*
      Prevent duplicate event listeners.
    */

    if (
      audio.__dtPrecisionWheelVersion ===
      VERSION
    ) {
      render();
      return true;
    }


    audio.__dtPrecisionWheelVersion =
      VERSION;


    audio.addEventListener(
      "play",
      startRendering
    );


    audio.addEventListener(
      "playing",
      startRendering
    );


    audio.addEventListener(
      "pause",
      render
    );


    audio.addEventListener(
      "ended",
      render
    );


    audio.addEventListener(
      "seeked",
      render
    );


    audio.addEventListener(
      "timeupdate",
      () => {
        if (audio.paused) {
          render();
        }
      }
    );


    /*
      Initial position.
    */

    render();


    return true;
  }


  /* =========================================================
     INITIALIZE

     distant-player.js may load slightly later,
     so wait for the shared player object.
  ========================================================= */

  function initialize() {
    if (bindAudio()) {
      return;
    }


    let attempts = 0;


    const timer =
      window.setInterval(
        () => {
          attempts++;


          if (
            bindAudio() ||
            attempts >= 100
          ) {
            window.clearInterval(
              timer
            );
          }

        },
        50
      );
  }


  /* =========================================================
     BOOT
  ========================================================= */

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      {
        once: true
      }
    );

  } else {
    initialize();
  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    "shopify:section:load",
    () => {
      window.setTimeout(
        initialize,
        0
      );
    }
  );

})();